export default __webpack_public_path__ + "static/media/medical-portal.15e92043.png";